// Örnek servis codiagno login
import axios from "../javascript/custom-axios";
const RESOURCE_NAME = "/emergency";
const RESOURCE_NAME2 = "/admin";
export default {
  getEmergencies( Page= 1, PageSize = 15, EventStatus = null) {
    return axios.get(`${RESOURCE_NAME2}/getAllEvents`, {
      params: { Page: Page, PageSize: PageSize, EventStatus: EventStatus },
    });
  },
  downloadEmergencyReport(id, fileName) {
    // return axios.get(`${RESOURCE_NAME2}/downloadEventReport/${id}`);

    return axios
      .get(
        `${process.env.VUE_APP_API_URL}${RESOURCE_NAME2}/downloadEventReport/${id}`,
        { responseType: "blob" }
      )
      .then((response) => {
        const url = URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `AcilDurum_${fileName}.xlsx`);
        link.click();
      });
  },
  getEmergencyStatus() {
    return axios.get(`${RESOURCE_NAME}/getEvent`);
  },

  createEmergency(body) {
    return axios.post(`${RESOURCE_NAME}/event/create`, body);
  },

  updateEmergency(body) {
    return axios.put(`${RESOURCE_NAME}/event/update`, body);
  },

  deleteEmergency(EventId) {
    return axios.put(`${RESOURCE_NAME2}/deleteEvent/${EventId}`);
  },
  setRescueTeam(body) {
    return axios.post(`${RESOURCE_NAME2}/setRescue`,body);
  },
  getUsersForRescueTeam(Page= 1, PageSize = 15) {
    return axios.get(`/admin/getUsersForRescue`, {
      params: { page: Page, pageSize: PageSize},
    });
  },
  getEventItems(eventId, status = "") {
    return axios.get(`${RESOURCE_NAME}/getUserByStatus`, {
      params: { eventId, status },
    });
  },
};
